export default "<p>edit-factura works!</p>\n"